import React from 'react';

import { Switch, Route } from 'react-router-dom'

//BrowserRouter
import UnderHeader from './pages/UnderHeader';
import NotFound from './pages/NotFound';
import About from './pages/About';
import Prices from './pages/Prices';
import Support from './pages/Support';
import Profile from './pages/Profile';
import LinkAccount from './pages/LinkAccount';
import Purchase from './pages/Purchase';
import Purchased from './pages/Purchased';
import PurchaseCancelled from './pages/PurchaseCancelled';
import ChangePass from './pages/ChangePass';
import ChangePassConfirmation from './pages/ChangePassConfirmation';
import UnlinkAccount from './pages/UnlinkAccount';
import ReAuthAccount from './pages/ReAuthAccount';
import ForgotPass from './pages/ForgotPass';
import Config from './Config';
import RecoveryPassConfirmation from './pages/RecoveryPassConfirmation';
import Entrance from './pages/Entrance';
import PrivateRoute from './other/PrivateRoute';

export default class Main extends React.Component {

  componentWillMount() {
    //to enforce entrance
    localStorage.setItem('is_authorized', 0);
  }

  render() {
    return (

      <Switch>
        <PrivateRoute exact path={Config.dirHostedAt+'/'} component={UnderHeader}/> 
        <PrivateRoute exact path={Config.dirHostedAt+'/main'} component={UnderHeader}/>
        <Route exact path={Config.dirHostedAt+'/login/'} component={Entrance}/>
        <Route exact path={Config.dirHostedAt+'/entrance/'} component={Entrance}/>
        <PrivateRoute exact path={Config.dirHostedAt+'/about/'} component={About}/>
        <PrivateRoute exact path={Config.dirHostedAt+'/prices/'} component={Prices}/>
        <PrivateRoute exact path={Config.dirHostedAt+'/support/'} component={Support}/>
        <PrivateRoute exact path={Config.dirHostedAt+'/profile/'} component={Profile}/>
        <PrivateRoute exact path={Config.dirHostedAt+'/link_account/'} component={LinkAccount} name='LinkAccount'/>
        <PrivateRoute exact path={Config.dirHostedAt+'/purchase/:id'} component={Purchase}/>
        <PrivateRoute exact path={Config.dirHostedAt+'/purchased/'} component={Purchased}/>
        <PrivateRoute exact path={Config.dirHostedAt+'/purchase_cancelled/'} component={PurchaseCancelled}/>
        <PrivateRoute exact path={Config.dirHostedAt+'/change_pass/'} component={ChangePass}/>
        <Route exact path={Config.dirHostedAt+'/confirm_change_pass/:key'} component={ChangePassConfirmation}/>
        <PrivateRoute exact path={Config.dirHostedAt+'/unlink_account/'} component={UnlinkAccount}/>
        <PrivateRoute exact path={Config.dirHostedAt+'/reauth_account/'} component={ReAuthAccount} name='ReAuthAccount'/>
        <Route exact path={Config.dirHostedAt+'/forgot_pass/'} component={ForgotPass}/>
        <Route exact path={Config.dirHostedAt+'/confirm_recovery_pass/:key/:email'} component={RecoveryPassConfirmation}/>
        <Route path={Config.dirHostedAt+'/:path*'} component={NotFound}/>

      </Switch>
    )
  }
}
